import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class BudgetSourcePropertyAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BudgetSourcePropertys';

  /**
   * Hàm lấy dữ liệu tính chất nguồn theo mã
   * @param {} id
   * @returns
   */
  async getBudgetPropertyByCode(code) {
    let request = {
      url: this.getAPIUrl() + '/getPropertyByCode',
      data: { code },
    };

    return await httpClient.getAsync(request);
  }
}

export default new BudgetSourcePropertyAPI();
